import { computed, defineComponent, inject, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import type { AccessFixIpRipeConfigPatchRequest } from "../../../infrastructure/gfo_api/order_api";
import { ApiValidationError } from "../../../infrastructure/gfo_api/api_validation_error";
import { de } from "date-fns/locale";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}
export default defineComponent({
  template: html,
  components: {  },
  emits: {
    next: () => true
  },
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const currentOrderProvider = inject(currentOrderProviderKey);
  
    // vars und computed
    const config = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.configs.find((c) => c.type == 'FixipRipeConfig' || c.type == 'AccessFiberConfig') ?? null
    });

    const ripeHandle = ref("");
    const ripeReason = ref("");
    const ripeHandleError = ref("");
    const ripeReasonError = ref("");

    // laufender Autosave-Request; validate() muss darauf warten, bevor es den
    // (sonst optimistisch geleerten) Fehlerstatus auswertet
    let pendingSave: Promise<void> | null = null;

    const save = async () => {
      const run = async () => {
        const conf = config.value as any;
        if (conf == null || orderService == null) {
          return;
        }
        if (conf.type == "FixipRipeConfig"){
          const request: AccessFixIpRipeConfigPatchRequest = {
            ripe_handle: ripeHandle.value || null,
            ripe_reason: ripeReason.value || null,
          };
          ripeHandleError.value = "";
          ripeReasonError.value = "";
          try{
            await orderService.patchConfig(conf["uuid"],conf.type, request);

          } catch(err){
            if (err instanceof ApiValidationError) {
              ripeHandleError.value = err.errors["ripeHandle"]?.[0] ?? "";
              ripeReasonError.value = err.errors["ripeReason"]?.[0] ?? "";
            } else {
              console.log(err);
            }
          }
        }
      };
      pendingSave = run();
      await pendingSave;
    }

    const isValid = computed(() => {
      if (!ripeHandle.value && !ripeReason.value) {
        return false;
      }
      return !ripeHandleError.value && !ripeReasonError.value;
    });

    const validate = async () => {
      if (pendingSave) {
        await pendingSave;
      }
      if (!ripeHandle.value && !ripeReason.value) {
        const message = t("ConfigsAccess_FixIp_OneRequired");
        ripeHandleError.value = message;
        ripeReasonError.value = message;
      }
      return isValid.value;
    };

    onMounted(function(){
      const conf = config.value as any;
      if (conf == null){
        return;
      }
      ripeHandle.value = conf.data.ripe_handle ?? "";
      ripeReason.value = conf.data.ripe_reason ?? "";
    })

    return {
      t,
      de,
      ripeHandle,
      ripeReason,
      ripeHandleError,
      ripeReasonError,
      save,
      isValid,
      validate,
    };
  },
} as any);
